import { createFileRoute } from '@tanstack/react-router';

import { dashboardRouteSearchSchema } from '../features/dashboard/dashboardRouteSearch';
import { IntegrationOverview } from '../features/demand/integrations/components/IntegrationDetailsPage/IntegrationOverview';

export const Route = createFileRoute(
  '/demand/integrations/$integrationId/demand/$demandPartnerId/details/overview',
)({
  validateSearch: dashboardRouteSearchSchema,
  component: IntegrationOverviewRoute,
});

function IntegrationOverviewRoute() {
  const { integrationId } = Route.useParams();
  return <IntegrationOverview integrationId={integrationId} />;
}
